'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('updateServerApp.booklist.edit', [])
  .controller('BookListEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/booklist/edit/index.js